export default {
    //API_ENDPOINT: 'http://localhost:8000/',
    API_ENDPOINT: 'https://enigmatic-escarpment-94058.herokuapp.com/',
    TOKEN_KEY: 'thoughtful-client-auth-token',
    API_KEY: '',
  }
